import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {ApprovalFlowSuccessor, successorInput} from './approval-flow-successor.model';

export const loadApprovalFlowSuccessors = createAction(
  '[ApprovalFlowSuccessor/API] Load ApprovalFlowSuccessors',
  props<{ approvalFlowSuccessors: ApprovalFlowSuccessor[] }>()
);

export const addApprovalFlowSuccessor = createAction(
  '[ApprovalFlowSuccessor/API] Add ApprovalFlowSuccessor',
  props<{ approvalFlowSuccessor: ApprovalFlowSuccessor }>()
);

export const upsertApprovalFlowSuccessor = createAction(
  '[ApprovalFlowSuccessor/API] Upsert ApprovalFlowSuccessor',
  props<{ approvalFlowSuccessor: ApprovalFlowSuccessor }>()
);

export const addApprovalFlowSuccessors = createAction(
  '[ApprovalFlowSuccessor/API] Add ApprovalFlowSuccessors',
  props<{ approvalFlowSuccessors: ApprovalFlowSuccessor[] }>()
);

export const upsertApprovalFlowSuccessors = createAction(
  '[ApprovalFlowSuccessor/API] Upsert ApprovalFlowSuccessors',
  props<{ approvalFlowSuccessors: ApprovalFlowSuccessor[] }>()
);

export const updateApprovalFlowSuccessor = createAction(
  '[ApprovalFlowSuccessor/API] Update ApprovalFlowSuccessor',
  props<{ approvalFlowSuccessor: Update<ApprovalFlowSuccessor> }>()
);

export const updateApprovalFlowSuccessors = createAction(
  '[ApprovalFlowSuccessor/API] Update ApprovalFlowSuccessors',
  props<{ approvalFlowSuccessors: Update<ApprovalFlowSuccessor>[] }>()
);

export const deleteApprovalFlowSuccessor = createAction(
  '[ApprovalFlowSuccessor/API] Delete ApprovalFlowSuccessor',
  props<{ id: string }>()
);

export const deleteApprovalFlowSuccessors = createAction(
  '[ApprovalFlowSuccessor/API] Delete ApprovalFlowSuccessors',
  props<{ ids: string[] }>()
);

export const clearApprovalFlowSuccessors = createAction(
  '[ApprovalFlowSuccessor/API] Clear ApprovalFlowSuccessors'
);


// CUSTOM

export const removeApprovalFlowStagesSuccessorMutation = createAction(
  '[ApprovalFlowSuccessor/API] delete Approval Flow Stages Successor Mutation',
  props<{ successorUniqueId: string ,id?:string}>()
);
